import {FaSpotify} from 'react-icons/fa'
import {getAuthUrl} from '../lib/spotify'
import styled from '../lib/styled-components'
import {LinkButton} from './Button'
import {Modal} from './Modal'

const Wrapper = styled.div`
  min-height: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
`

const Intro = styled.p`
  color: ${p => p.theme.colors.primary};
`

export const LoginModal = ({
  onClose,
  open = true
}: {
  open?: boolean
  onClose: () => void
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Wrapper>
        <Intro>Click the link below to authenticate with Spotify.</Intro>
        <LinkButton
          style={{maxWidth: '100px'}}
          icon={<FaSpotify />}
          to={getAuthUrl()}
        >
          Login
        </LinkButton>
      </Wrapper>
    </Modal>
  )
}
